<template>
    <base-button type="warning" size="sm" @click="handleClick" class="mr-2">
        <i class="fa fa-edit fa-fw"></i>Modificar
    </base-button>
</template>
<script>
export default {
    name: "update-button",
    methods: {
        handleClick(evt) {
            this.$emit("click", evt);
        }
    }
};
</script>
<style>
</style>